module.exports = __webpack_public_path__ + "img/ceflore-thumbnail-benefits.a0b9a25b.webp";